import { render, staticRenderFns } from "./DtDormitoryInfo.vue?vue&type=template&id=6be4d0e3&"
import script from "./DtDormitoryInfo.vue?vue&type=script&lang=js&"
export * from "./DtDormitoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports